import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import InlineNotice from "src/components/InlineNotice"
import Loader from "src/components/Loader"

import { getInvoice } from "src/api/Billing/Payments"

import InvoiceActivity from "./InvoiceActivity"
import InvoiceHeader from "./InvoiceHeader"
import InvoiceProductsTable from "./InvoiceProductsTable"
import InvoiceStats from "./InvoiceStats"

const InvoiceDetail = ({ invoiceId }) => {
  const { marinaSlug } = useMarina()
  const {
    data: invoice,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["invoiceDetail", marinaSlug, invoiceId],
    queryFn: () => getInvoice({ marinaSlug, invoiceId }),
  })

  if (isLoading) return <Loader name="invoice" />
  if (isError)
    return (
      <div className="mx-auto max-w-[860px] px-4 py-6">
        <InlineNotice variant="error">
          We couldn’t load this invoice. Try refreshing the page.
        </InlineNotice>
      </div>
    )

  return (
    <div className="mx-auto flex max-w-[1200px] flex-col gap-6 px-4 pb-6">
      <InvoiceHeader invoice={invoice} />
      {invoice.hiddenFromBillingLists && (
        <InlineNotice variant="info">
          {`${invoice.displayId} is $0, so it no longer appears in billing lists.`}
        </InlineNotice>
      )}
      <InvoiceStats invoice={invoice} />
      <InvoiceProductsTable
        invoiceId={invoice.id}
        lines={invoice.lines}
        totalCents={invoice.totalCents}
      />
      <InvoiceActivity activity={invoice.activity} />
    </div>
  )
}

InvoiceDetail.propTypes = {
  invoiceId: PropTypes.string.isRequired,
}

export default InvoiceDetail
